module.exports = __webpack_public_path__ + "img/cwell3.714a0acd.jpg";